export default "__VITE_ASSET__CuaXiVBn__"